<template>
<v-row align="center" justify="center">
  <v-col  :sm="12" :md="7" :lg="5" :xl="5">
    <div class="tes-card pa-4 mt-6">
      <div class="mt-6 text-center">
        <p class="font-weight-bold">Уважаемый клиент!</p>
        <span>
          Вами не был предоставлен доступ для проверки состояния указанного
          прибора учёта (ПУ) электроэнергии, в связи с чем введённые сейчас
          показания ПУ не будут учитываться при расчёте платы за коммунальную
          услугу "электроснабжение". В дальнейшем, в случае предоставления
          доступа для проверки состояния прибора учёта, расчёт платы за
          коммунальную услугу "электроснабжения" согласно показаниям будет
          возобновлён. Для этого вам необходимо передать заполненное заявление в
          ближайшее подразделение АО "Татэнергосбыт"
        </span>
      </div>
    </div>
  </v-col>
</v-row>
</template>

<script>
export default {
  name: "change-tariff-notif",
};
</script>